module.exports = __webpack_public_path__ + "img/water-dac699a.png";